(function(root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define(['jquery', './Wiretap'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node, CommonJS-like
        module.exports = factory(require('jquery'), require('./Wiretap'));
    } else {
        // Browser globals (root is window)
        root.WiretapApp = factory(root.jQuery, root.Wiretap);
    }
})(this, function($, Wiretap) {
    'use strict';

    /**
     * WiretapApp - Analytics tracking for page-level interactions.
     * @param {object}   trackingConfig A JSON object of events to track.
     * @param {function} tokenHelpers   (optional) Function helpers to replace tracking event tokens.
     * @param {object}   pageConfig     (optional) Additional static page data.
     * @constructor
     */
    function WiretapApp(trackingConfig, tokenHelpers, pageConfig) {
        WiretapApp.prototype.super.constructor.call(
            this,
            trackingConfig,
            tokenHelpers,
            pageConfig
        );

        // Set the top-level scope for the delegated events.
        var scope = this.trackingConfig.scope
            ? this.trackingConfig.scope
            : 'body';
        this.$SCOPE = $(scope);

        _initListeners.call(this);
    }

    // Inherit from Wiretap
    WiretapApp.prototype = Object.create(Wiretap);
    WiretapApp.prototype.constructor = WiretapApp;
    WiretapApp.prototype.super = Wiretap.prototype;

    var propertyData = {
        default: {
            sponsor: 'MLB',
            siteName: 'Major League Baseball'
        },
        milb: {
            sponsor: 'MiLB',
            siteName: 'Minor League Baseball'
        }
    };

    /**
     * Track a user action within the app.
     * @param {object} data Proxy data containing the tracking object.
     * @param {object} e    The DOM element's event.
     */
    WiretapApp.prototype.trackEventHandler = function(data, e) {
        if (!data.trackObj) {
            return false;
        }

        var adobeObj = this.setTrackingProps(
            $.extend(true, {}, data.trackObj),
            $(e.currentTarget)
        );

        if (adobeObj) {
            this.prototype.track(adobeObj);
            e.stopPropagation();
        }
    };

    /**
     * Set the variables inside the tracking event object.
     * Should be overridden by the custom section implementations.
     * @param  {object} trackObj Config properties.
     * @param  {jquery} $el      The jquery event element.
     */
    WiretapApp.prototype.setTrackingProps = function(trackObj, $el) {
        var appVars = this.pageConfig;
        var _this = this;
        var parent;
        var replacement;

        // Replace any variables within each prop value.
        $.each(trackObj, function(prop, value) {
            value = value.toString();

            if (value.indexOf('@') !== -1) {
                if (value.match(/@INDEX_\w+@/)) {
                    parent =
                        trackObj.wire && trackObj.wire.parent
                            ? trackObj.wire.parent
                            : null;
                    value = _this.util.setIndex(value, $el, parent);
                }
                if (value.match(/@TEXT@/)) {
                    value = _this.util.setText(value, $el);
                }
                if (value.match(/@TEAM_ABBREV@/)) {
                    replacement = appVars.teamAbbrev
                        ? appVars.teamAbbrev
                        : '[Team - unavailable]';
                    value = value.replace(/@TEAM_ABBREV@/, replacement);
                }
                if (value.match(/@SITE_TRAFFIC@/)) {
                    replacement = appVars.siteTraffic
                        ? appVars.siteTraffic
                        : '[Site traffic - unavailable]';
                    value = value.replace(/@SITE_TRAFFIC@/, replacement);
                }
                if (value.match(/@SITE_NAME@/)) {
                    replacement = appVars.teamDisplay
                        ? appVars.teamDisplay
                        : getPropertySpecificValue(
                              appVars.property,
                              'siteName'
                          );
                    value = value.replace(/@SITE_NAME@/, replacement);
                }
                if (value.match(/@MEDIA_SPONSOR@/)) {
                    replacement = getPropertySpecificValue(
                        appVars.property,
                        'sponsor'
                    );
                    value = value.replace(/@MEDIA_SPONSOR@/, replacement);
                }
                if (value.match(/@LANG_LOCALE@/)) {
                    replacement = appVars.langLocale
                        ? appVars.langLocale
                        : '[Lang locale - unavailable]';
                    value = value.replace(/@LANG_LOCALE@/, replacement);
                }

                trackObj[prop] = value;
            }

            // Remove any bad props.
            if (trackObj[prop] == 'undefined' || trackObj[prop] == null) {
                delete trackObj[prop];
            }
        });

        return trackObj;
    };

    /**
     * Helpers
     */
    WiretapApp.prototype.util = {
        /**
         * Set variable with the text content of an element or parent.
         * @param value     The tracking value.
         * @param $el       The active DOM element.
         * @param parent    The parent or grandparent element.
         */
        setText: function(value, $el, parent) {
            var text = parent ? $el.parents(parent.s).text() : $el.text();
            text = text.trim().replace(/\s+/g, ' ');

            return value.replace(/@TEXT@/g, text);
        },
        /**
         * Set variable with the index number of an element or parent.
         * @param value     The tracking value.
         * @param $el       The active DOM element.
         * @param zeroIndex Start at 0 or 1.
         * @param parent    The parent or grandparent element.
         */
        setIndex: function(value, $el, parent, zeroIndex) {
            var index;
            var offset;

            if (value.match(/@INDEX_\d+_PARENT@/) && parent) {
                index = $el.parents(parent.s).index();
            } else {
                index = $el.index();
            }

            if (value.match(/@INDEX_0/)) {
                offset = 0;
            } else if (value.match(/@INDEX_1/)) {
                offset = 1;
            }

            // TODO - support the case with multiple unique replacements within a single prop value.
            return value.replace(/@INDEX_\w+@/g, index + offset);
        }
    };

    /**
     * Initialize element listeners for user event tracking.
     */
    function _initListeners() {
        var _this = this;
        var events = _this.trackingConfig.app;
        var eventType;

        for (var e in events) {
            if (!(events[e].wire && events[e].wire.selector)) {
                return true;
            }

            eventType = events[e].wire.eventType
                ? events[e].wire.eventType
                : 'click';

            if (events[e].wire.defaults) {
                $.extend(
                    events[e],
                    _this.trackingConfig.defaults[events[e].wire.defaults]
                );
            }

            // Specify the event handler.
            var eventHandler = $.proxy(_this.trackEventHandler, _this, {
                trackObj: events[e]
            });

            // Attach handler to the app event.
            _this.$SCOPE.on(eventType, events[e].wire.selector, eventHandler);
        }
    }

    /**
     * Get values specific to a supported property site.
     * @param property   The site key.
     * @param key        The value to get.
     * @returns {string}
     */
    function getPropertySpecificValue(property, key) {
        property =
            typeof property == 'string' ? property.toLowerCase() : 'default';

        var data = propertyData[property] || propertyData.default;

        return data && data[key] ? data[key] : '[' + key + ' - unavailable]';
    }

    return WiretapApp;
});
